import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IImageIconProps extends IConDefaultType {}

function ImageIcon({ color, className, size = 24, rotate, flip }: IImageIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" width="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 2H8C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8V16C2 17.5913 2.63214 19.1174 3.75736 20.2426C4.88258 21.3679 6.4087 22 8 22H16C17.5913 22 19.1174 21.3679 20.2426 20.2426C21.3679 19.1174 22 17.5913 22 16V8C22 6.4087 21.3679 4.88258 20.2426 3.75736C19.1174 2.63214 17.5913 2 16 2ZM4 8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42142 6.93913 4 8 4H16C17.0609 4 18.0783 4.42142 18.8284 5.17157C19.5786 5.92172 20 6.93913 20 8V16C19.9987 16.2587 19.9719 16.5166 19.92 16.77L16.4 14.54C15.8372 14.1701 15.1785 13.973 14.505 13.973C13.8315 13.973 13.1728 14.1701 12.61 14.54L12.25 14.78C12.0553 14.9151 11.8216 14.9824 11.5849 14.9716C11.3481 14.9607 11.1215 14.8723 10.94 14.72L8.53 12.72C7.96089 12.2488 7.24935 11.9835 6.51065 11.9672C5.77195 11.9508 5.04938 12.1844 4.46 12.63L4 13V8ZM16 20H8C6.93913 20 5.92172 19.5786 5.17157 18.8284C4.42143 18.0783 4 17.0609 4 16V15.5L5.67 14.25C5.89388 14.0698 6.17262 13.9716 6.46 13.9716C6.74738 13.9716 7.02612 14.0698 7.25 14.25L9.66 16.25C10.1733 16.6773 10.8113 16.9268 11.4784 16.961C12.1454 16.9953 12.8056 16.8125 13.36 16.44L13.72 16.2C13.9563 16.0405 14.2349 15.9553 14.52 15.9553C14.8051 15.9553 15.0837 16.0405 15.32 16.2L19.05 18.55C18.6781 18.9995 18.2124 19.3622 17.6855 19.6127C17.1587 19.8631 16.5834 19.9953 16 20Z"
          fill={color || '#8A8A8A'}
        />
        <path
          d="M14.5 12C13.837 12 13.2011 11.7366 12.7322 11.2678C12.2634 10.7989 12 10.163 12 9.5C12 8.83696 12.2634 8.20107 12.7322 7.73223C13.2011 7.26339 13.837 7 14.5 7C15.163 7 15.7989 7.26339 16.2678 7.73223C16.7366 8.20107 17 8.83696 17 9.5C17 10.163 16.7366 10.7989 16.2678 11.2678C15.7989 11.7366 15.163 12 14.5 12ZM14.5 9C14.3674 9 14.2402 9.05268 14.1464 9.14645C14.0527 9.24021 14 9.36739 14 9.5C14 9.63261 14.0527 9.75979 14.1464 9.85355C14.2402 9.94732 14.3674 10 14.5 10C14.6326 10 14.7598 9.94732 14.8536 9.85355C14.9473 9.75979 15 9.63261 15 9.5C15 9.36739 14.9473 9.24021 14.8536 9.14645C14.7598 9.05268 14.6326 9 14.5 9Z"
          fill={color || '#8A8A8A'}
        />
      </svg>
    </i>
  );
}

export default ImageIcon;
